/* script */
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isFunction } from 'lodash';

// Components
import AssetsList from 'shared/ui/components/media/AssetsList.vue';

const __vue_script__ = {
    name: 'AssetsLibrary',

    components: { AssetsList },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            ready: false,
            currentPage: 1,
            total: 0,
            assets: [],
            limit: this.$services.documents.MAX_DOCS_PER_PAGE,
            unsubscribeListener: null
        };
    },

    async created() {
        this.loadAssets();
        const channel = `document/${this.$services.documents.PRINTABLE_ASSET_TYPE}/update`;
        const listener = signal => this.onAttachmentLinked(signal);
        this.unsubscribeListener = await this.$services.signal.addSignalListener(channel, listener);
    },

    beforeDestroy() {
        if (isFunction(this.unsubscribeListener)) {
            this.unsubscribeListener();
        }
    },

    methods: {

        /**
         * Loads the assets list
         *
         * @param {number} [page=1] the page to load
         */
        async loadAssets(page = this.currentPage) {
            try {
                const eventId = this.params.event._id;
                const { items, total } = await this.$services.documents.getAllDocsByType(eventId, this.$services.documents.PRINTABLE_ASSET_TYPE, { skip: (page - 1) * this.limit, countAll: 1 });

                this.total = total;
                this.assets = items;
                this.ready = true;
                this.currentPage = page;

            } catch (error) {
                console.error('[AssetsLibrary] Could not load assets list due to an error:', error.message);
            }
        },

        /**
         * Updates listing when the attachment is linked to asset document
         *
         * @param {object} signal
         */
        onAttachmentLinked(signal) {
            const asset = this.assets.find(a => a._id === signal.targetId);

            if (asset) {
                this.$set(asset, 'fp_attachments_s3', signal.document.fp_attachments_s3);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assets-library"},[(_vm.ready)?_c('assets-list',{attrs:{"event":_vm.params.event,"total-assets":_vm.total,"assets-per-page":_vm.limit,"assets":_vm.assets},on:{"update":function($event){return _vm.loadAssets()},"page-changed":_vm.loadAssets}}):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AssetsLibrary.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__